"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApAppBar = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApAppBar = function (_a) {
    var backgroundColor = _a.backgroundColor, children = _a.children, className = _a.className, isFluid = _a.isFluid, left = _a.left, padding = _a.padding, position = _a.position, right = _a.right, thin = _a.thin;
    return (React.createElement(styles_1.StyledAppBar, { backgroundColor: backgroundColor, padding: padding, position: position, className: "ap-app-bar " + (className ? className : '') },
        React.createElement(styles_1.StyledAppBarInner, { isFluid: isFluid },
            left && (React.createElement(styles_1.StyledAppBarLeftContent, { thin: thin }, left())),
            right && (React.createElement(styles_1.StyledAppBarRightContent, { thin: thin }, right())),
            !left && !right && (React.createElement(styles_1.StyledAppBarContent, { thin: thin }, children)))));
};
exports.ApAppBar.defaultProps = {
    isFluid: false,
    position: 'fixed',
    thin: false,
};
//# sourceMappingURL=ApAppBar.js.map